module.exports = __webpack_public_path__ + "img/تجاری.7801e800.jpg";